import {
  registerReactCustomDetailComponent,
  registerReactDataTableComponent,
} from "@bb-vendure/admin-ui/react";
import CustomsClearanceSection from "./components/CustomsClearanceSection";
import CustomsClearanceState from "./components/CustomsClearanceState";
import CustomsClearanceAction from "./components/CustomsClearanceAction";
import { registerFormInputComponent } from "@bb-vendure/admin-ui/core";
import { registerCustomDetailComponent } from "@bb-vendure/admin-ui/core";
import { CustomsClearanceActiveSection } from "./components/CustomsClearanceActiveSection/customs-clearance-active-section.component";

export default [
  registerReactCustomDetailComponent({
    locationId: "order-detail",
    component: CustomsClearanceSection,
  }),
  registerReactDataTableComponent({
    tableId: "order-list",
    columnId: "customsClearanceId",
    component: CustomsClearanceAction,
  }),
  registerReactDataTableComponent({
    tableId: "order-list",
    columnId: "customsClearanceStatusCol",
    component: CustomsClearanceState,
  }),
  // registerCustomDetailComponent({
  //   locationId: "shipping-method-detail",
  //   component: CustomsClearanceActiveSection,
  // }),
  registerFormInputComponent(
    "customs-clearance-active-toggle",
    CustomsClearanceActiveSection
  ),

  //registerReactFormInputComponent('test-input', TestCustomField),
];
